// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
export function escapeRegExp(string) {
  return string.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&');
}
function removeSpecialCharacters(string) {
  return string.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~-]/g, '');
}

/* Pattern to match the query at a word boundary (special characters removed, case insensitive).
 * Word boundary should also work w/ unicode characters - e.g. Japanese
 * see https://shiba1014.medium.com/regex-word-boundaries-with-unicode-207794f6e7ed
 *
 * Unit tests for regex, English: https://regex101.com/r/Gj2rRZ/2
 * Unit tests for regex, Japanese: https://regex101.com/r/wVd4yU/2
 *
 * FIXME AP-27500: This regex does not match words mid-sentence for JP strings.
 */
function getWordBoundaryRegex(query) {
  return new RegExp(`(?<=[\\s,.:;"']|^)${removeSpecialCharacters(query)}`, 'i');
}
export function doesQueryMatchString(query, string) {
  try {
    return getWordBoundaryRegex(removeSpecialCharacters(query)).test(removeSpecialCharacters(string));
  } catch {
    // If the regex fails due to browser incompatibility, we'll fall back to a simple case-insensitive match
    // Context: https://square.slack.com/archives/C0173S0K9ME/p1706829403274309?thread_ts=1706827321.841399&cid=C0173S0K9ME
    return string.toLowerCase().includes(query.toLowerCase());
  }
}